<div class="flex h-screen bg-gray-50">
  <!-- Toast Messages -->
  <p-toast></p-toast>
  
  <!-- Sidebar Navigation -->
  <app-side-nav
    [activeRoute]="'letters'"
    [isOpen]="isSidebarOpen"
    (sidebarClose)="onSidebarClose()"
  ></app-side-nav>

  <!-- Main Content Area -->
  <div class="flex-1 flex flex-col overflow-hidden">
    <!-- Page Header -->
    @if (userProfile) {
    <app-page-header
      [greeting]="''"
      [userProfile]="userProfile"
      [showHamburger]="true"
      (sidebarToggle)="onSidebarToggle()"
    ></app-page-header>
    }

  <!-- Upload Content -->
  <main *ngIf="!isPageLoading" class="flex-1 overflow-y-auto p-6">
    <!-- Back Navigation and Title -->
    <div class="mb-6 flex items-center justify-between">
      <button
        (click)="onCancel()"
        class="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
      >
        <i class="pi pi-arrow-left text-gray-600 text-sm mr-2"></i>
        <span class="text-xl font-semibold">{{
          isEditMode ? "Edit Document" : "Upload New Document"
        }}</span>
      </button>

      <!-- Refresh button for loading data -->
      <button
        *ngIf="usersLoadError || sourcesLoadError"
        (click)="refreshAllData()"
        class="flex items-center px-3 py-2 text-sm bg-teal-100 text-teal-700 rounded-lg hover:bg-teal-200 transition-colors"
        title="Refresh data"
      >
        <i class="pi pi-refresh mr-2"></i>
        Refresh Data
      </button>
    </div>

    <!-- Main Content Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <!-- Left Side - Form -->
      <div class="space-y-6">
        <form [formGroup]="uploadForm" class="space-y-6">
          <!-- Document Name -->
          <div>
            <label
              for="documentName"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Document Name
            </label>
            <input
              type="text"
              id="documentName"
              formControlName="documentName"
              placeholder="Enter name"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              [class.border-red-500]="hasFieldError('documentName')"
            />
            <div
              *ngIf="hasFieldError('documentName')"
              class="text-red-500 text-sm mt-1"
            >
              {{ getFieldError("documentName") }}
            </div>
          </div>

          <!-- Due Date -->
          <div>
            <label
              for="dueDate"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Due Date
            </label>
            <div class="relative">
              <p-datepicker
                #dueDatePicker
                id="dueDate"
                formControlName="dueDate"
                [defaultDate]="
                  isEditMode ? uploadForm.get('dueDate')?.value : null
                "
                appendTo="body"
                [minDate]="computedMinDate"
                [showIcon]="true"
                [showButtonBar]="true"
                dateFormat="dd/mm/yy"
                placeholder="Select due date"
                [class.border-red-500]="hasFieldError('dueDate')"
                class="w-full"
                [readonlyInput]="false"
                [showOnFocus]="true"
              ></p-datepicker>
            </div>
            <div
              *ngIf="hasFieldError('dueDate')"
              class="text-red-500 text-sm mt-1"
            >
              {{ getFieldError("dueDate") }}
            </div>
          </div>

          <!-- Assigned Users -->
          <div>
            <label
              for="assignedUsers"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Assigned Users
            </label>
            <p-multiselect
              id="assignedUsers"
              formControlName="assignedUsers"
              [options]="assignedUsers"
              optionLabel="name"
              [placeholder]="
                isLoadingUsers
                  ? 'Loading users...'
                  : usersLoadError
                  ? 'Failed to load users'
                  : 'Select user'
              "
              [disabled]="isLoadingUsers || usersLoadError"
              [showToggleAll]="true"
              [showHeader]="true"
              [class.border-red-500]="
                hasFieldError('assignedUsers') || usersLoadError
              "
              styleClass="w-full"
              [filter]="true"
              filterPlaceholder="Search users..."
              appendTo="body"
            ></p-multiselect>
            <!-- Error state with retry button -->
            <div
              *ngIf="usersLoadError"
              class="mt-2 p-2 bg-red-50 border border-red-200 rounded-md"
            >
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <i class="pi pi-exclamation-triangle text-red-500 mr-2"></i>
                  <span class="text-sm text-red-700">Failed to load users</span>
                </div>
                <button
                  type="button"
                  (click)="retryLoadUsers()"
                  class="text-xs px-2 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors"
                >
                  Retry
                </button>
              </div>
            </div>
            <!-- Debug information -->
            <div
              class="text-xs text-gray-500 mt-1"
              *ngIf="
                assignedUsers.length === 0 && !isLoadingUsers && !usersLoadError
              "
            >
              No users available
            </div>
            <div
              *ngIf="hasFieldError('assignedUsers')"
              class="text-red-500 text-sm mt-1"
            >
              {{ getFieldError("assignedUsers") }}
            </div>
          </div>

            <!-- Source -->
            <div>
              <label
                for="source"
                class="block text-sm font-medium text-gray-700 mb-2"
              >
                Source
              </label>
              <p-select
                id="source"
                formControlName="source"
                [options]="sources"
                optionLabel="name"
                optionValue="id"
                [placeholder]="
                  isLoadingSources ? 'Loading sources...' : 'Select a source'
                "
                [disabled]="isLoadingSources"
                [class.border-red-500]="hasFieldError('source')"
                styleClass="w-full"
                appendTo="body"
                [showClear]="false"
              ></p-select>
              <!-- Debug information for sources -->
              <div
                class="text-xs text-gray-500 mt-1"
                *ngIf="sources.length === 0 && !isLoadingSources"
              >
                No sources available
              </div>
              <!-- <div
                class="text-xs text-gray-500 mt-1"
                *ngIf="sources.length > 0"
              >
                {{ sources.length }} sources loaded
              </div> -->
              <div
                *ngIf="hasFieldError('source')"
                class="text-red-500 text-sm mt-1"
              >
                {{ getFieldError("source") }}
              </div>
            </div>
          </form>
        </div>

      <!-- Right Side - Upload Area or Document Display -->
      <div class="flex flex-col">
        <!-- Edit Mode: Show Uploaded Document -->
        <div *ngIf="isEditMode && uploadedFileName" class="flex-1">
          <div class="border border-gray-200 rounded-lg p-6 bg-white shadow-sm">
            <h3 class="text-lg font-medium text-gray-900 mb-4">
              Current Document
            </h3>

            <!-- Document Info Card -->
            <div class="bg-gray-50 rounded-lg p-4 mb-4">
              <div class="flex items-center space-x-3">
                <!-- File Icon -->
                <div class="flex-shrink-0">
                  <i [class]="getFileIcon()" class="text-2xl text-gray-600"></i>
                </div>

                <!-- File Details -->
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ uploadedFileName }}
                  </p>
                  <p class="text-xs text-gray-500 mt-1">
                    {{ getFileExtension().toUpperCase() }} Document
                  </p>
                </div>

                <!-- Download Button -->
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    (click)="downloadUploadedFile()"
                    class="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
                  >
                    <i class="pi pi-download mr-2"></i>
                    Download
                  </button>
                </div>
              </div>
            </div>

            <!-- Upload New File Section -->
            <div class="border-t border-gray-200 pt-4">
              <h4 class="text-sm font-medium text-gray-900 mb-3">
                Replace Document
              </h4>
              <div
                class="border-2 border-dashed border-gray-300 rounded-lg p-4 flex flex-col items-center justify-center transition-colors upload-area"
                [class.border-teal-500]="isDragOver"
                [class.bg-teal-50]="isDragOver"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)"
                (drop)="onDrop($event)"
              >
                <!-- Upload Icon -->
                <svg
                  class="w-8 h-8 text-gray-400 mb-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                  ></path>
                </svg>

                <!-- Upload Text -->
                <div class="text-center">
                  <p class="text-sm font-medium text-gray-900 mb-1">
                    Upload New Document
                  </p>
                  <p class="text-xs text-gray-500 mb-2">
                    Drag and drop your file here, or click to browse
                  </p>
                  <p class="text-xs text-gray-400 mb-3">
                    Maximum file size: 15MB
                  </p>
                </div>

                <!-- File Input -->
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  (change)="onFileSelected($event)"
                  class="hidden"
                  #fileInput
                />
                <button
                  type="button"
                  (click)="fileInput.click()"
                  class="px-3 py-1.5 bg-teal-600 text-white text-sm rounded-md hover:bg-teal-700 transition-colors"
                >
                  Choose File
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Create Mode: Show Upload Interface -->
        <div *ngIf="!isEditMode || !uploadedFileName" class="flex-1">
          <div
            class="flex-1 border-2 border-dashed border-gray-300 rounded-lg p-8 flex flex-col items-center justify-center transition-colors upload-area"
            [class.border-teal-500]="isDragOver"
            [class.bg-teal-50]="isDragOver"
            [class.drag-over]="isDragOver"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
          >
            <!-- Upload Icon -->
            <svg
              class="w-12 h-12 text-gray-400 mb-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              ></path>
            </svg>

            <!-- Upload Text -->
            <div class="text-center">
              <p class="text-lg font-medium text-gray-900 mb-2">
                Upload Document
              </p>
              <p class="text-sm text-gray-500 mb-2">
                Drag and drop your file here, or click to browse
              </p>
              <p class="text-xs text-gray-400 mb-4">Maximum file size: 15MB</p>
            </div>

            <!-- File Input -->
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              (change)="onFileSelected($event)"
              class="hidden"
              #fileInput
            />
            <button
              type="button"
              (click)="fileInput.click()"
              class="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
            >
              Choose File
            </button>
          </div>
        </div>

        <!-- File Size Error Display -->
        <div
          *ngIf="fileSizeError"
          class="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg w-full file-error"
        >
          <div class="flex items-center">
            <svg
              class="w-5 h-5 text-red-500 mr-2 flex-shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <span class="text-sm text-red-700">{{ fileSizeError }}</span>
          </div>
        </div>

        <!-- Selected File Display (for new uploads) -->
        <div
          *ngIf="
            selectedFile && !fileSizeError && (!isEditMode || !uploadedFileName)
          "
          class="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg w-full"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center file-info">
              <svg
                class="w-5 h-5 text-green-500 mr-2 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <div>
                <span class="text-sm text-green-700 font-medium file-name">{{
                  getFileName()
                }}</span>
                <p class="text-xs text-green-600 mt-1 file-size">
                  {{ formatFileSize(selectedFile.size) }}
                </p>
              </div>
            </div>
            <button
              type="button"
              (click)="removeFile()"
              class="text-red-500 hover:text-red-700 transition-colors remove-file-btn"
              title="Remove file"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- New File Display (for edit mode when replacing) -->
        <div
          *ngIf="
            selectedFile && !fileSizeError && isEditMode && uploadedFileName
          "
          class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg w-full"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center file-info">
              <svg
                class="w-5 h-5 text-blue-500 mr-2 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <div>
                <span class="text-sm text-blue-700 font-medium file-name">{{
                  getFileName()
                }}</span>
                <p class="text-xs text-blue-600 mt-1 file-size">
                  {{ formatFileSize(selectedFile.size) }} (will replace current
                  document)
                </p>
              </div>
            </div>
            <button
              type="button"
              (click)="removeFile()"
              class="text-red-500 hover:text-red-700 transition-colors remove-file-btn"
              title="Remove file"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex justify-end space-x-4 mt-8">
      <button
        type="button"
        (click)="onCancel()"
        class="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onSave()"
        class="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="
          !uploadForm.valid ||
          (!selectedFile && !isEditMode && !uploadedFileName) ||
          fileSizeError
        "
      >
        {{ isEditMode ? "Update" : "Save" }}
      </button>
    </div>
  </main>
</div>
